import React from "react";
import styled from "styled-components";
import EducationCard from "../Cards/EducationCard";
import { education } from "../../data/constants";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  padding: 60px 0 80px 0;
  @media (max-width: 960px) {
    padding: 40px 0 60px 0;
  }
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1150px;
  gap: 16px;
  padding: 0 20px;
`;

const Tag = styled.div`
  background: rgba(133, 76, 230, 0.12);
  border: 1px solid rgba(133, 76, 230, 0.4);
  color: #c084fc;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  padding: 6px 18px;
  border-radius: 9999px;
  box-shadow: 0 0 15px rgba(133, 76, 230, 0.2);
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const Title = styled.h2`
  font-size: 38px;
  font-weight: 700;
  text-align: center;
  color: ${({ theme }) => theme.text_primary};
  margin: 0;
  letter-spacing: -0.02em;

  @media (max-width: 768px) {
    font-size: 30px;
  }
`;

const SubTitle = styled.p`
  font-size: 16px;
  text-align: center;
  max-width: 650px;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.6;
  margin: 0 0 24px 0;

  @media (max-width: 768px) {
    font-size: 14.5px;
  }
`;

const TimelineContainer = styled.div`
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 10px;

  /* Timeline glowing line */
  &::before {
    content: "";
    position: absolute;
    top: 25px;
    bottom: 25px;
    left: 20px;
    width: 2px;
    background: linear-gradient(
      180deg,
      #854CE6 0%,
      #be1adb 50%,
      #38bdf8 100%
    );
    box-shadow: 0 0 12px rgba(133, 76, 230, 0.6);
  }

  @media (max-width: 640px) {
    &::before {
      left: 14px;
    }
  }
`;

const TimelineItemWrapper = styled.div`
  display: flex;
  gap: 28px;
  position: relative;
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 640px) {
    gap: 16px;
  }
`;

const TimelineNode = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #171721;
  border: 2px solid #854CE6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  z-index: 2;
  box-shadow: 0 0 16px rgba(133, 76, 230, 0.6);
  position: relative;

  &::after {
    content: "";
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #c084fc;
    box-shadow: 0 0 10px #c084fc;
  }

  @media (max-width: 640px) {
    width: 30px;
    height: 30px;

    &::after {
      width: 8px;
      height: 8px;
    }
  }
`;

const CardContainer = styled.div`
  flex-grow: 1;
  width: 100%;
`;

const Education = () => {
  return (
    <Container id="education">
      <Wrapper>
        <Tag>Academic Journey</Tag>
        <Title>Education & Background</Title>
        <SubTitle>
          My formal educational background and foundational computer science
          qualifications.
        </SubTitle>

        <TimelineContainer>
          {education.map((item, index) => (
            <TimelineItemWrapper key={index}>
              <TimelineNode />
              <CardContainer>
                <EducationCard education={item} />
              </CardContainer>
            </TimelineItemWrapper>
          ))}
        </TimelineContainer>
      </Wrapper>
    </Container>
  );
};

export default Education;